import { Icon } from '../../ui/Icon.js';
import { useI18n } from '../../i18n/i18n.js';
import { useInspectStore } from './inspectMode.js';

/**
 * Lock switch: open projects without saving or logging anything.
 * `beforeOn` runs before the switch takes effect, e.g. to save own changes still pending.
 */
export function ViewOnlyToggle({
  iconOnly = false,
  beforeOn,
}: {
  iconOnly?: boolean;
  beforeOn?: () => Promise<void>;
}) {
  const on = useInspectStore((s) => s.on);
  const setOn = useInspectStore((s) => s.setOn);
  const { m } = useI18n();
  const toggle = async () => {
    if (!on && beforeOn) await beforeOn();
    setOn(!on);
  };
  return (
    <button
      type="button"
      className={`btn${on ? ' btn-view-only' : ' btn-quiet'}${iconOnly ? ' btn-icon' : ''}`}
      aria-pressed={on}
      aria-label={m.inspect.toggle}
      title={m.inspect.title}
      onClick={() => void toggle()}
      data-testid="view-only-toggle"
    >
      <Icon name={on ? 'lock' : 'unlock'} />
      {!iconOnly && <span className="btn-label">{m.inspect.toggle}</span>}
    </button>
  );
}
